import { makeStyles } from '@material-ui/core/styles'
import { getOutlinedTextFieldWrapperStyles } from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    width: '100%',
  },
  formContainer: {
    maxWidth: 832,
    margin: '0 auto',
    padding: theme.spacing(4, 2, 6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(3, 2, 12),
      gap: theme.spacing(2.5),
    },
  },
  formCardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2.5, 2),
      gap: theme.spacing(2.5),
    },
  },
  optionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  optionControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(2.5),
    },
  },
  formFieldsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(2.5),
    },
  },
  rowIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    color: '#172024',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  rowBody: {
    flex: 1,
    minWidth: 0,
  },
  rowTitle: {
    margin: 0,
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
  },
  rowDescription: {
    margin: theme.spacing(0.5, 0, 0),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  fieldLabel: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  sectionLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  ageTilesBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  formField: {
    ...getOutlinedTextFieldWrapperStyles(theme),
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2.5),
    },
  },
  ageChoiceGroup: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    width: '100%',
  },
  ageChoiceDivider: {
    backgroundColor: '#E0E0E0',
  },
  ageChoiceCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    boxSizing: 'border-box',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
      gap: theme.spacing(1.5),
    },
  },
  ageChoiceCardDisabled: {
    cursor: 'not-allowed',
  },
  ageChoiceIcon: {
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    color: '#172024',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  ageChoiceBody: {
    flex: 1,
    minWidth: 0,
  },
  ageChoiceTitle: {
    margin: 0,
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
  },
  ageChoiceDescription: {
    margin: theme.spacing(0.5, 0, 0),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  ageChoiceRadioRoot: {
    flexShrink: 0,
    padding: theme.spacing(0.5),
    color: '#40484C',
    pointerEvents: 'none',
  },
  ageChoiceRadioChecked: {
    color: '#0053FF',
  },
}))

export default useStyles
